import ApiService from '../services/ApiService';

import { Address } from './models/Address';

export default class AddressStore {
  constructor(private apiService: ApiService) {}

  public fetchAddressResult(queryString: string): Promise<Address[]> {
    if (!queryString) {
      return Promise.resolve([]);
    }
    return this.apiService.getAddressSuggestions(queryString).catch(() => {
      return [];
    });
  }
}
